import { useCallback, useState } from 'react'

import { resetCrudSelection } from '@/atoms'
import { deleteDepots } from '@/features/domain/depot'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { unproxify } from '@/utils'

import { useController } from './useController'

export function useDeleteDepots() {
  const [submitting, setSubmitting] = useState(false)

  const {
    data: { depotIds },
    close,
  } = useController()
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const isUnmounted = useIsUnmounted()

  const submit = useCallback(async () => {
    try {
      setSubmitting(true)
      const ids = unproxify(depotIds)

      const result = await dispatch(deleteDepots(ids))

      if (isUnmounted()) return

      if (!deleteDepots.fulfilled.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }

      resetCrudSelection('depots')
    } catch (e) {
      toast.error(e.message)
    } finally {
      close?.()
      setSubmitting(false)
    }
  }, [dispatch, toast, depotIds, close, isUnmounted])

  return [submitting, submit] as const
}
